import React, {Component} from 'react';
import {NavBar, Tabs} from 'antd-mobile';
import EndShunt from './endShunt';
import StartShunt from './startShunt';
import './style.less';
import {connect} from "react-redux";
let numIndex = 0;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class ShuntOrder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabs: [
                {title: '出发分流'},
                {title: '到达分流'},
            ],
        };
    }

    componentDidMount() {
        console.log(this.props)
        if(this.props.location.state !== undefined){
            const orderData = this.props.location.state.orderData;
            if(orderData.orderType == '接'){
                this.setState({tabs:[{title: '出发分流'},]});
            }else{
                this.setState({tabs:[{title: '到达分流'},]});
            }
        }
    }

    onChange = (tab, index) => {
        numIndex = index;
    };

    render() {
        return (
            <div className="shuntOrder">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                >分流下单</NavBar>

                {
                    this.props.location.state == undefined ?
                        <Tabs
                            tabs={this.state.tabs}
                            onChange={(tab, index) => this.onChange(tab, index)}
                            initialPage={numIndex}
                            useOnPan={false}
                            swipeable={false}
                            animated={true}
                            prerenderingSiblingsNumber={false}
                        >
                            <StartShunt {...this.props} /><EndShunt {...this.props} />
                        </Tabs>
                    :( this.props.location.state.orderData.orderType == '接' ?
                        <Tabs
                            tabs={this.state.tabs}
                            onChange={(tab, index) => this.onChange(tab, index)}
                            // initialPage={stateRrderData == undefined ? null:(stateRrderData.orderData.orderType == '接' ? 0:1) }
                            initialPage={numIndex}
                            useOnPan={false}
                            swipeable={false}
                            animated={true}
                            prerenderingSiblingsNumber={false}
                        >
                            <StartShunt {...this.props} />
                        </Tabs>:
                        <Tabs
                            tabs={this.state.tabs}
                            onChange={(tab, index) => this.onChange(tab, index)}
                            // initialPage={stateRrderData == undefined ? null:(stateRrderData.orderData.orderType == '接' ? 0:1) }
                            initialPage={numIndex}
                            useOnPan={false}
                            swipeable={false}
                            animated={true}
                            prerenderingSiblingsNumber={false}
                        >
                            <EndShunt {...this.props} />
                        </Tabs>)

                }

                {/*<Tabs
                    tabs={this.state.tabs}
                    onChange={(tab, index) => this.onChange(tab, index)}
                    // initialPage={stateRrderData == undefined ? null:(stateRrderData.orderData.orderType == '接' ? 0:1) }
                    initialPage={numIndex}
                    useOnPan={false}
                    swipeable={false}
                    animated={true}
                    prerenderingSiblingsNumber={false}
                >
                    <StartShunt {...this.props} />
                    <EndShunt {...this.props} />
                </Tabs>*/}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Home/changeRole/Shunt/shuntOrder/index.js